var exports = {
  "kL": "x31de4314--87fe51--container",
  "Kk": "x31de4314--87fe51--icon",
  "y_": "x31de4314--87fe51--remoteness",
};

module.exports = exports;
